<template>
<div id="reach">
<v-app id="inspire">
      <v-container
        fluid
        style="min-height: 0;"
        grid-list-lg
        text-xs-center
      >
        <v-layout row wrap>
          <v-flex xl12 lg12 sm12 xs12>
          <v-card-text>
            <h3 style="text-align:center"><span style="color: rgba(0,0,0,1); font-weight:bold;"> <span>How to Reach Meherabad</span></span></h3>
            <p style="text-align:justify"><strong>Meherabad</strong> is located on Daund Road six kilometers outside the city of Ahmednagar, Maharashtra State, India. </p>
          </v-card-text>

          <v-expansion-panel>
            <v-expansion-panel-content ripple>
              <div slot="header">Travel By Air</div>

                <v-card-text class="grey lighten-3"><p  style="text-align:justify">The nearest airports are at Pune and Aurangabad, both approximately two and one half hours from Ahmednagar by road. The nearest international airport is Mumbai, approximately five hours by road to Ahmednagar.</p></v-card-text>

            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-divider></v-divider>
          <v-expansion-panel>
            <v-expansion-panel-content ripple>
              <div slot="header">Travel by Rail</div>

                <v-card-text class="grey lighten-3"><p  style="text-align:justify">Located on the Daund/Manmad railway line, Ahmednagar is accessible by rail from many Indian cities, both to the north and south, including Delhi, Bangalore, and Hyderabad. Local rail service to/from Pune and Mumbai is not generally convenient as the trains are slow. </p></v-card-text>

            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-divider></v-divider>
          <v-expansion-panel>
            <v-expansion-panel-content ripple>
              <div slot="header">Travel by Car</div>

                <v-card-text class="grey lighten-3"><p  style="text-align:justify">Buses and taxis reach Ahmednagar from Pune, Aurangabad, Sholapur, and Nasik. A direct road from Mumbai, which bypasses Pune, takes about five hours in light traffic.</p></v-card-text>

            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-flex>
        <v-flex xl12 lg12 sm12 xs12 d-flex>
          <v-flex xl6 lg6 sm6 xs6 style="padding: 0px;"><v-btn style="width: 70%;" id="button" @click="samadhi"><v-icon>location_on</v-icon>Samadhi</v-btn></v-flex>
          <v-flex xl6 lg6 sm6 xs6 style="padding: 0px;"><v-btn style="width: 70%;" id="button" @click="mpr"><v-icon>location_on</v-icon>MPR</v-btn></v-flex>
        </v-flex>
        <v-flex xl12 lg12 sm12 xs12 d-flex>
          <v-flex xl6 lg6 sm6 xs6 style="padding: 0px;"><v-btn style="width: 70%;" id="button" @click="mpc"><v-icon>location_on</v-icon>MPC</v-btn></v-flex>
          <v-flex xl6 lg6 sm6 xs6 style="padding: 0px;"><v-btn style="width: 70%;" id="button" @click="hosteld"><v-icon>location_on</v-icon>Hostel-D</v-btn></v-flex>
        </v-flex>
			<!-- <v-btn id="button" @click="samadhi"><v-icon>location_on</v-icon>Samadhi</v-btn> -->
			&nbsp;
			<!-- <v-btn id="button" @click="mpr"><v-icon>location_on</v-icon>MPR</v-btn> -->
			&nbsp;
			<!-- <v-btn id="button" @click="hosteld"><v-icon>location_on</v-icon>Hostel-D</v-btn> -->
      </v-layout>
    </v-container>
  </v-app>
</div>
</template>
<script>
  export default {
    methods: {
      samadhi () {
        location.href = 'geo:<19.030994>,<74.714059>?q=<19.030994>,<74.714059>(THE AVATAR MEHER BABA SAMADHI, MEHERABAD)'
      },
      mpr () {
        location.href = 'geo:<19.035537>,<74.706945>?q=<19.035537>,<74.706945>(MEHER PILGRIM RETREAT - MPR, MEHERABAD)'
      },
      mpc () {
        location.href = 'geo:<19.0288018>,<74.7189833>?q=<19.0288018>,<74.7189833>(MEHER PILGRIM CENTER - MPC, MEHERABAD)'
      },
      hosteld () {
        location.href = 'geo:<19.028747>,<74.720657>?q=<19.028747>,<74.720657>(HOSTEL D, MEHERABAD)'
      }
    }
  }
</script>
<style>

  #reach {
    background-image: linear-gradient(rgba(255, 255, 255, 0.45),rgba(255, 255, 255, 0.45)), url("/static/doc-images/lists/airbg.png");
    background-size: cover;
  }
p{
  color: black;
  font-weight: bold;
}

#button {
  background-color: rgba(146, 182, 209,0.8);
  margin: auto;
  width: 32%;
  display: block;
}
</style>


// WEBPACK FOOTER //
// air.vue?fdb5318e